import React, { createContext, useState } from "react";
import { useQuery } from "react-query";
import { USERS } from "../config/apiConfig";
import axios from "../config/axiosInstance";
import { ModalTerms } from "../components/modals/ModalTerms";

const ApplicationContext = createContext();

const PermissionProvider = ({ children }) => {
  const token = localStorage.getItem("token");
  const [isUserRefetchPaused, setUserRefetchPaused] = useState(false);
  const { data: user, refetch } = useQuery(
    ["user"],
    async () => {
      try {
        const { data } = await axios.get(`${USERS.GET_USER_CURRENT}`);

        return data.data;
      } catch (error) {
        throw error;
      }
    },
    {
      enabled: !!token,
      refetchOnWindowFocus: !isUserRefetchPaused,
      onError: (error) => {
        const currentPath = window.location.pathname;
        if (error.response?.status === 401 && currentPath !== "/login") {
          localStorage.removeItem("token");
          window.location.href = "/login";
        }
      },
    }
  );

  return (
    <ApplicationContext.Provider
      value={{
        user,
        userPermission: user?.permissionId,
        refetchUser: refetch,
        isUserRefetchPaused,
        setUserRefetchPaused,
      }}
    >
      {children}
      {!!user && !user?.Company?.termsAcceptedAt && <ModalTerms />}
    </ApplicationContext.Provider>
  );
};

const useApplication = () => React.useContext(ApplicationContext);

export { PermissionProvider, useApplication };
